import styled from 'styled-components'

import { createIcon } from '@blade/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type DataTableHeaderSortingProps = {
  sorting: 'asc' | 'desc' | undefined
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
  size?: number
  active: boolean
} & ClassNameProps

export const DataTableHeaderSortingSingle: React.FC<
  DataTableHeaderSortingProps
> = ({ className, sorting, onClick, size = 10, active }) => {
  if (!sorting) {
    return undefined
  }
  const Icon = sorting === 'desc' ? DownIcon : UpIcon
  return (
    <Root data-active={active} className={className} onClick={onClick}>
      <Icon size={size} />
    </Root>
  )
}

const Root = styled.div`
  color: var(--data-table-header-color);
  cursor: pointer;
  display: grid;

  &[data-active='true'] {
    color: var(--primary-9);
  }
`

const UpIcon = createIcon(
  <>
    <path
      d="M8.5 3.9651C8.49983 4.10261 8.45827 4.23696 8.38062 4.35097C8.30298 4.46498 8.19278 4.55348 8.0641 4.60516C7.93542 4.65685 7.79411 4.66937 7.65821 4.64113C7.52231 4.61289 7.398 4.54517 7.30115 4.44662L5.69996 2.8609L5.69996 8.79859C5.70126 8.89023 5.68417 8.98121 5.64966 9.06625C5.61516 9.15129 5.56393 9.22869 5.49896 9.29396C5.43398 9.35922 5.35656 9.41104 5.27119 9.44641C5.18581 9.48179 5.09419 9.5 5.00165 9.5C4.90911 9.5 4.81749 9.48179 4.73211 9.44641C4.64674 9.41104 4.56932 9.35922 4.50434 9.29396C4.43937 9.22869 4.38814 9.15129 4.35364 9.06625C4.31913 8.98121 4.30204 8.89023 4.30334 8.79859L4.30334 2.8609L2.70215 4.44662C2.6378 4.513 2.56073 4.56599 2.47545 4.60249C2.39017 4.639 2.29839 4.65828 2.20548 4.65922C2.11258 4.66015 2.02042 4.64272 1.9344 4.60794C1.84839 4.57317 1.77024 4.52174 1.70455 4.45668C1.63885 4.39162 1.58692 4.31423 1.55181 4.22904C1.51669 4.14386 1.49909 4.05259 1.50004 3.96058C1.50098 3.86858 1.52045 3.77768 1.55731 3.69322C1.59418 3.60876 1.64768 3.53244 1.7147 3.46871L4.50793 0.702473C4.63889 0.572829 4.81648 0.500001 5.00165 0.500001C5.18682 0.500001 5.36441 0.572829 5.49537 0.702473L8.2886 3.46871C8.35557 3.53324 8.4088 3.61042 8.44511 3.69568C8.48142 3.78095 8.50009 3.87256 8.5 3.9651Z"
      fill="currentColor"
    />
  </>,
  '0 0 10 10',
)

const DownIcon = createIcon(
  <>
    <path
      d="M8.5 6.0349C8.49983 5.89739 8.45827 5.76304 8.38062 5.64903C8.30298 5.53502 8.19278 5.44652 8.0641 5.39484C7.93542 5.34315 7.79411 5.33063 7.65821 5.35887C7.52231 5.38711 7.398 5.45483 7.30115 5.55338L5.69996 7.1391L5.69996 1.20141C5.70126 1.10977 5.68417 1.01879 5.64966 0.933748C5.61516 0.848708 5.56393 0.771308 5.49896 0.706046C5.43398 0.640783 5.35656 0.58896 5.27119 0.553589C5.18581 0.518217 5.09419 0.500002 5.00165 0.500002C4.90911 0.500002 4.81749 0.518217 4.73211 0.553589C4.64674 0.58896 4.56932 0.640783 4.50434 0.706046C4.43937 0.771308 4.38814 0.848708 4.35364 0.933748C4.31913 1.01879 4.30204 1.10977 4.30334 1.20141L4.30334 7.1391L2.70215 5.55338C2.6378 5.48701 2.56073 5.43402 2.47545 5.39751C2.39017 5.36101 2.29839 5.34172 2.20548 5.34079C2.11258 5.33985 2.02042 5.35728 1.9344 5.39206C1.84839 5.42684 1.77024 5.47826 1.70455 5.54332C1.63885 5.60838 1.58692 5.68577 1.55181 5.77096C1.51669 5.85614 1.49909 5.94741 1.50004 6.03942C1.50098 6.13142 1.52045 6.22232 1.55731 6.30678C1.59418 6.39124 1.64768 6.46756 1.7147 6.53129L4.50793 9.29753C4.63889 9.42717 4.81648 9.5 5.00165 9.5C5.18682 9.5 5.36441 9.42717 5.49537 9.29753L8.2886 6.53129C8.35557 6.46676 8.4088 6.38958 8.44511 6.30432C8.48142 6.21905 8.50009 6.12744 8.5 6.0349Z"
      fill="currentColor"
    />
  </>,
  '0 0 10 10',
)
